import IReporter, { IReporterContructor } from '../interfaces/IReporter';

import { ITrackingServerConfig } from '../interfaces/ITrackingServerConfig';

export default class ReporterFactory {
    public static Create<T extends IReporter>(type: IReporterContructor<T>, config: ITrackingServerConfig): T {
    // eslint-disable-next-line new-cap
        const reporter: T = new type(config);
        return reporter;
    }
}
